<template>
  <div class="pc_container">
    <!-- 头部 -->
    <div class="category-header">
      <h2 class="title">{{ title || $t('_a._default_title') }}</h2>
      <router-link :to="{ name: moreUrl }" class="more-link">
        {{ $t('_a._gd') }}
        <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>

    <!-- 视频列表：一行4个 -->
    <ul class="video-grid">
      <li class="video-card" v-for="(item, index) in videoList" :key="index">
        <router-link :to="{ name: 'video', query: { code: item.code } }" class="card-link">
          <div class="card-cover">
            <img :src="item.img" :alt="item.title" loading="lazy" />
            <!-- 悬停浮层 -->
            <div class="cover-hover">
              <div class="hover-content">
                <h4 class="hover-title">{{ item.title }}</h4>
                <p class="hover-desc">{{ item.content || item.desc || '暂无简介' }}</p>
                <button class="play-btn">
                  <i class="fas fa-play"></i> {{ $t('_a._bf') || '播放' }}
                </button>
              </div>
            </div>
            <span class="badge" v-if="item.badge">{{ item.badge }}</span>
          </div>
          <h3 class="card-title">{{ item.title }}</h3>
        </router-link>
      </li>
    </ul>

    <div class="empty-state" v-if="videoList.length === 0">
      <i class="fas fa-video-slash"></i>
      <p>{{ $t('_a._empty') || '暂无视频' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemVue',
  props: {
    title: {
      type: String,
      default: ''
    },
    cateId: {
      type: Number,
      default: 0
    },
    moreUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      videoList: []
    }
  },
  watch: {
    cateId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getVideoList()
        }
      },
      immediate: false
    }
  },
  created() {
    this.getVideoList()
  },
  methods: {
    getVideoList() {
      this.$api.video
        .getVideoList({
          page: 1,
          cate_id: this.cateId,
          size: 15
        })
        .then((res) => {
          this.videoList = res.data || []
        })
        .catch(() => {
          this.videoList = []
        })
    }
  }
}
</script>

<style scoped>
.pc_container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background-color: #0b0d0f;
  color: #e8edf2;
}

/* ===== 头部 ===== */
.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #1e2329;
}

.category-header .title {
  font-size: 22px;
  font-weight: 700;
  color: #f0f4f8;
  letter-spacing: 0.5px;
  margin: 0;
}

.more-link {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8a949f;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  transition: color 0.3s ease, background 0.3s ease;
}

.more-link:hover {
  color: #e8edf2;
  background: rgba(255, 255, 255, 0.08);
}

.more-link i {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.more-link:hover i {
  transform: translateX(4px);
}

/* ===== 网格：一行4个 ===== */
.video-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0;
}

/* ===== 卡片：固定宽高 220x290 ===== */
.video-card {
  width: 220px;
  background: #13191f;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #1e2329;
  /* 卡片本身没有任何过渡动画，杜绝闪烁 */
  transition: none;
}

.card-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

/* ===== 封面：固定 220x290 ===== */
.card-cover {
  position: relative;
  width: 220px;
  height: 290px;
  background: #0f1419;
  overflow: hidden;
  flex-shrink: 0;
}

.card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* ⭐ 只有图片缩放，过渡平滑 */
  transition: transform 0.4s ease;
  display: block;
}

/* ⭐ 悬停时只有图片轻微缩放 */
.video-card:hover .card-cover img {
  transform: scale(1.06);
}

/* ===== 悬停浮层 ===== */
.cover-hover {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 16px;
  pointer-events: none;
}

.video-card:hover .cover-hover {
  opacity: 1;
  pointer-events: auto;
}

.hover-content {
  text-align: center;
  max-width: 100%;
}

.hover-title {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 6px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
}

.hover-desc {
  font-size: 12px;
  color: #c8d4e0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0 0 12px 0;
  opacity: 0.85;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}

.play-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e50914;
  color: #fff;
  border: none;
  padding: 6px 20px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;
}

.play-btn:hover {
  background: #b20710;
}

.play-btn i {
  font-size: 12px;
}

/* ===== 角标 ===== */
.badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(229, 9, 20, 0.88);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 10px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  z-index: 2;
}

/* ===== 卡片标题 ===== */
.card-title {
  font-size: 14px;
  font-weight: 500;
  color: #e8edf2;
  padding: 10px 12px 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== 空状态 ===== */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #5e6a76;
  grid-column: 1 / -1;
}

.empty-state i {
  font-size: 48px;
  opacity: 0.4;
  margin-bottom: 12px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* ===== 响应式 ===== */
@media (max-width: 1200px) {
  .video-grid {
    justify-items: center;
  }
}

@media (max-width: 1024px) {
  .video-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .pc_container {
    padding: 12px 12px 30px;
  }
  .video-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  .video-card {
    width: 100%;
    max-width: 220px;
  }
  .card-cover {
    width: 100%;
    height: auto;
    aspect-ratio: 220 / 290;
  }
  .category-header .title {
    font-size: 18px;
  }
  .hover-title {
    font-size: 14px;
  }
  .hover-desc {
    font-size: 12px;
    -webkit-line-clamp: 2;
  }
  .play-btn {
    padding: 5px 16px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .video-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .video-card {
    max-width: 100%;
  }
  .card-cover {
    aspect-ratio: 220 / 290;
  }
  .card-title {
    font-size: 13px;
    padding: 8px 10px 10px;
  }
  .badge {
    font-size: 9px;
    padding: 2px 8px;
    top: 6px;
    left: 6px;
  }
}
</style>